/**
 * Holds the MixpanelPluginV2 instance created by `createLunaAnalyticsClient()` so the few
 * capabilities that fall outside the shared `AnalyticsClient` contract can still reach it:
 *
 * - Mixpanel group properties (the `Org ID` group), which the legacy plugin set inside
 *   `identify()` and which `AnalyticsClient` has no method for.
 * - Session Replay start/pause/resume/stop, used by the carrier registration funnel.
 *
 * Everything else must go through `useAnalytics()` — this module is not a general escape
 * hatch for tracking.
 */
import type MixpanelPluginV2 from '@satellite/plugins/MixpanelPluginV2.js';

let instance: MixpanelPluginV2 | null = null;

export function registerLunaMixpanelInstance(plugin: MixpanelPluginV2): void {
  instance = plugin;
}

/**
 * Throws rather than returning null, mirroring `useAnalytics()`: a missing instance means a
 * broken bootstrap. A registered instance still no-ops without a Mixpanel token (dev, QA, e2e).
 *
 * @throws Error when `createLunaAnalyticsClient()` has not run
 */
export function getLunaMixpanelInstance(): MixpanelPluginV2 {
  if (!instance) {
    throw new Error(
      'Missing Mixpanel instance: createLunaAnalyticsClient() must run before any tracking call'
    );
  }

  return instance;
}
